import {Component, EventEmitter, Input, NgModule, NO_ERRORS_SCHEMA, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { ItemsTransactions } from '../itemstransactions';
import { SharedService } from '../../../../services/index';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {Message} from 'primeng/components/common/api';
import {MessageService} from 'primeng/components/common/messageservice';
import { AppLogComponent } from '../../../../components/app-log/app-log.component'
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {InvoicesShowComponent} from "../../../pos/invoices/invoices-show/invoices-show.component";
import {ReturninvoicesShowComponent} from "../../../pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {ItemsTransactionsService} from "../itemstransactions.service";
import {ItemService} from "../../../setting/items/items.service";
import {RequestOptions, ResponseContentType} from "@angular/http";
import {appConfig} from "../../../../app.config";
import {RefundsShowComponent} from "../../refunds/refunds-show/refunds-show.component";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule} from "primeng/primeng";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {AccountsService} from "../../../fin/accounts/accounts.service";
import {AccountReportService} from "../../../fin/account_report/account_report.service";
import {CostcentersService} from "../../../fin/costcenters/costcenters.service";
import {PurchasesShowComponent} from "../../purchases/purchases-show/purchases-show.component";
import {InventoryShowComponent} from "../../inventory/inventory-show/inventory-show.component";
import {DepreciationShowComponent} from "../../depreciation/depreciation-show/depreciation-show.component";
import {ExchangeShowComponent} from "../../exchange/exchange-show/exchange-show.component";

@NgModule({
  imports: [CommonModule, FormsModule, DropdownModule, MyInputsModule, ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
  ],
  declarations: [
    ItemsTransactionsListComponent
  ],
  entryComponents: [
    ItemsTransactionsListComponent
  ],
  exports: [],
  providers: [SharedService,  MessageService, ConfirmationService, ItemsTransactionsService,ItemService],
  schemas: [NO_ERRORS_SCHEMA]
})

@Component({
  selector: 'app-itemstransactions-list',
  templateUrl: './itemstransactions-list.component.html',
  styleUrls: ['./itemstransactions-list.component.scss'],
  providers: [ ConfirmationService , MessageService,ItemsTransactionsService,ItemService]
})
export class ItemsTransactionsListComponent implements OnInit {
  public items: any[]=[];
  public totalRec: number;
  public page: number;
  public per_page: number;
  public sortCol = '';
  public colname = '';
  public creationid = '';
  public sum: any = [];
  public sumval: any = [];
  public item:any;
  public branch:any;
  public creationuser:any;
  public costcenter:any;
  balances = [0];
  public ShowTotals = true;
  public ShowLastSub = true;
  public ShowZeroAccounts = true;
  isModel = false;
  // total_debit = 0;
  // total_credit = 0;
  oldData:any;
  startcount = 0;

  docTypes = ['Older','Other','Purchases','Purchases Return','Invoice','Invoice Return','','','inventory','depreciation','exchange','exchange'];

  public systemName = '';
  public userid = 0;

  filterdata: any ={};
  filterForm: FormGroup;
  msgs: Message[] = [];
  fromDate='';
  toDate='';

  @Input() refShow;
  @Output() update_event = new EventEmitter();

  public columns: any[]=[];
  public selected: any[];
  public allcolumns: any;
  public listcolumns: any[]=[];
  public userRoles: any[]=[];
  public hiddenFields: any[] = [];


  private _newButton: any;
  private _searchButton: any;
  private _printButton: any;
  private _excelButton: any;

  modelName = 'itemstransactions';

  componentData:any;

  constructor ( private router: Router,
                private route: ActivatedRoute,
                private itemService: ItemService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private sharedservice: SharedService,
                private totalReport: ItemsTransactionsService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {

    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: 'excelButton' },
        { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
    ]);
    this.oldData = {'debit':0,'credit':0};

  }



  ngOnInit() {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      // console.log(this.userRoles);
      this.systemName = userdata.systems[0];
      this.userid = userdata.id;
    }

    this.loadingPage();
  }
  balance(valued,valuec,i) {
    this.balances[i] = this.balances[i-1]+(parseFloat(valued)-parseFloat(valuec));
    return this.balances[i];
  }
  loadingPage() {
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
      { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: 'excelButton' }
    ]);
    this.update_event.emit(null);
    this.refShow = this.sharedservice.getItemShow();

    if(localStorage.getItem('tansactionFilter')) {
      this.filterdata = JSON.parse(localStorage.getItem('tansactionFilter'));
      this.fromDate = this.filterdata['from_date'];
      this.toDate = this.filterdata['to_date'];
      if(this.filterdata['item_id']) {
        this.itemService.getById(this.filterdata['item_id']).subscribe(
          item => {
            this.item = item;
          },
          err => {
            console.log(err);
          });
      }
      this.costcenter = this.filterdata['cost_center_id'];
      this.ShowTotals = (this.filterdata['BalanceOnly'])?false:true;
      this.ShowLastSub = (this.filterdata['MasterOnly'])?false:true;
      this.ShowZeroAccounts = (this.filterdata['HideZeros'])?false:true;

    } else {
      this.redirectNewPage();
    }
    if(!localStorage.getItem('finalFilter')) {
      this._searchButton = document.getElementById('searchButton');
      this._printButton = document.getElementById('printButton');
      this._excelButton = document.getElementById('excelButton');

      if (this._searchButton) {
        this._searchButton.onclick = ((e: any) => {
          e.preventDefault();
          this.redirectNewPage();
        });
      }
      if (this._printButton) {
        this._printButton.onclick = ((e: any) => {
          e.preventDefault();
          this.print();
        });
      }

      if (this._excelButton) {
        this._excelButton.onclick = ((e: any) => {
          e.preventDefault();
          this.excel();
        });

      }
    }

    this.getAll();

  }

  print() {
    const params = new URLSearchParams();
    let currentfilter = JSON.parse(localStorage.getItem('tansactionFilter'));
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key]);
      }
    }

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    const tokenapi = userdata.api_token;
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    params.set('token', tokenapi);
    window.open(appConfig.apiUrl + 'itemstransactions/print?'+ params.toString() );
  }

  excel() {
    const params = new URLSearchParams();
    let currentfilter = JSON.parse(localStorage.getItem('tansactionFilter'));
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key]);
      }
    }

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    const tokenapi = userdata.api_token;
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    params.set('token', tokenapi);
    window.open(appConfig.apiUrl +'itemstransactions/excel?'+ params.toString() );
  }



  loadPage(page: number) {
    if (page !== this.page) {
      this.page = page;
      this.getAll();
    }
  }



  redirectNewPage() {
    this.router.navigate(['/itemstransactions']);
  }

  sortPage(sortCol: string) {
    if (sortCol === this.sortCol) {
      sortCol = '-' + sortCol;
    } else {
      this.page = 1;
    }
    this.sortCol = sortCol;
    this.getAll();
  }

  getAll() {
    this.totalReport.getAll(this.page, this.sortCol ).subscribe(
      items => {
        this.item = items.item;
        this.branch = items.branch;
        this.items = items.actions;
        this.creationuser = items.creationuser;

      },
      err => {
        console.log(err);
      }

    );

  }

  openpopup(doc,type) {

    if(type === 0) {
      // const modalRef = this.modalService.open(JournalsShowComponent);
      // modalRef.componentInstance.refShow = this.refShow;
      // modalRef.componentInstance.scrId = doc;
    } else if(type === '2') {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === '3') {
      const modalRef = this.modalService.open(RefundsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === '4') {
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === '5') {
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === '8') {
       const modalRef = this.modalService.open(InventoryShowComponent);
       modalRef.componentInstance.refShow = this.refShow;
       modalRef.componentInstance.scrId = doc;
    } else if(type === '9') {
       const modalRef = this.modalService.open(DepreciationShowComponent);
       modalRef.componentInstance.refShow = this.refShow;
       modalRef.componentInstance.scrId = doc;
    } else if(type === '10' || type === '11') {
       const modalRef = this.modalService.open(ExchangeShowComponent);
       modalRef.componentInstance.refShow = this.refShow;
       modalRef.componentInstance.scrId = doc;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/itemstransactions/itemstransactions-list/itemstransactions-list.component.ts